import { service } from '@ember/service';

import BaseAuthenticator from 'ember-simple-auth/authenticators/base';

export default class MicrosoftAuthenticator extends BaseAuthenticator {
  // Services
  @service currentUser;
  @service intl;
  @service msal;
  @service session;

  // Functions
  async authenticate(tokenResponse) {
    const currentUser = await this.currentUser.load({
      headers: { Authorization: `Bearer ${tokenResponse.accessToken}` },
    });

    if (!currentUser) {
      throw new Error(this.intl.t('authenticator.microsoft.no_user'));
    }

    return {
      user: currentUser.displayLabel,
    };
  }

  async restore() {
    const tokenResponse = await this.msal.getAccessToken();
    const currentUser = await this.currentUser.load({
      headers: { Authorization: `Bearer ${tokenResponse?.accessToken}` },
    });

    if (!currentUser) {
      return Promise.reject();
    }

    return {
      user: currentUser.displayLabel,
    };
  }

  invalidate() {
    return Promise.resolve();
  }
}
